import { TableCell, TableHead, TableBody, TableRow, Grid, Paper, Table, TableContainer } from "@material-ui/core";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import {  useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getComprobantesPorEstado } from "../../../actions/compras/AuditoriaFactura";
import { ComprobantesItem } from "./ComprobantesItem";
import moment from "moment";

export const ListadoComprobantesPorEstado = () =>{
    const dispatch = useDispatch();
    const classes = useStyles();
    const { comprobantesPorEstado, estadosFacturacionSelect, fechaInicioAuditoria, fechaFinAuditoria, idSolicitudAuditoria } = useSelector((state) => state.auditoriaFacturacion);
    const { afiliadoSeleccionado } = useSelector((state) => state.autorizaciones);

    useEffect(() => {
        dispatch(getComprobantesPorEstado(
            estadosFacturacionSelect,
            afiliadoSeleccionado?.id_afiliado || null,
            idSolicitudAuditoria,
            moment(fechaInicioAuditoria).startOf('days'),
            moment(fechaFinAuditoria).endOf('days')
            ));
    }, [dispatch,
        estadosFacturacionSelect,
        afiliadoSeleccionado,
        idSolicitudAuditoria,
        fechaInicioAuditoria,
        fechaFinAuditoria]);

    console.log(comprobantesPorEstado);
    return (
        <div>
            <Grid>
                <Grid container justify="center" className={classes.root} spacing={1}>
                    <Grid item xs={12}>
                        <Paper>
                            <TableContainer component={Paper} style={{ overflowX: "auto", marginTop: '1rem', padding: '0.5rem' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell style={{textAlign:'center'}}>Numero de Orden</TableCell>
                                            <TableCell style={{textAlign:'center'}}>Tipo de Comprobante</TableCell>
                                            <TableCell style={{textAlign:'center'}}>N°de Comprobante</TableCell>
                                            <TableCell style={{textAlign:'center'}}>Razon Social</TableCell>
                                            <TableCell style={{textAlign:'center'}}>Cuit</TableCell>
                                            <TableCell style={{textAlign:'center'}}>N° Carnet</TableCell>
                                            <TableCell style={{textAlign:'center'}}>Total Comprobante/Cotizacion</TableCell>
                                            <TableCell style={{textAlign:'center'}}>Nro Solicitud Pago</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            comprobantesPorEstado.length > 0 ? (
                                                comprobantesPorEstado.map((item) => (
                                                    <ComprobantesItem
                                                        comprobante={item}
                                                        key={item.idExpediente.toString()}
                                                        estado={estadosFacturacionSelect}
                                                    />
                                                ))
                                            ) : (
                                                <TableRow style={{ height: 50 }}>
                                                    <TableCell
                                                        colSpan={13}
                                                        style={{ textAlign: "-webkit-center" }}
                                                    >
                                                        {" "}
                                                        Sin Registros
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
};